"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.Noise = exports.Pattern = exports.Wrapper = void 0;
var polished_1 = require("polished");
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../../theme");
var noise_1 = require("./noise");
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  background-color: ", ";\n"], ["\n  position: relative;\n  background-color: ", ";\n"])), function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return $backgroundColor ? theme_1.theme.colors[$backgroundColor] : '';
});
var PATTERN_BACKGROUND = function (color) { return ({
    left: {
        image: "radial-gradient(ellipse at 0% 40%, ".concat(theme_1.theme.colors[color], " 0%, ").concat(theme_1.theme.colors[color], " 40%, ").concat((0, polished_1.rgba)(theme_1.theme.colors[color], 0), " 100%)"),
        size: '100% 200%',
    },
    center: {
        image: "radial-gradient(ellipse at center center, ".concat(theme_1.theme.colors[color], " 0%, ").concat(theme_1.theme.colors[color], " 35%, ").concat((0, polished_1.rgba)(theme_1.theme.colors[color], 0), " 100%)"),
        size: '100% 150%',
    },
}); };
exports.Pattern = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-image: ", ";\n  background-repeat: repeat;\n  background-position: center center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: ", ";\n    background-size: ", ";\n    background-position: center center;\n  }\n"], ["\n  background-image: ", ";\n  background-repeat: repeat;\n  background-position: center center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: ", ";\n    background-size: ", ";\n    background-position: center center;\n  }\n"])), function (_a) {
    var $url = _a.$url;
    return "url(\"".concat($url, "\")");
}, function (_a) {
    var $gradientColor = _a.$gradientColor, $contentFocus = _a.$contentFocus;
    return PATTERN_BACKGROUND($gradientColor)[$contentFocus].image;
}, function (_a) {
    var $gradientColor = _a.$gradientColor, $contentFocus = _a.$contentFocus;
    return PATTERN_BACKGROUND($gradientColor)[$contentFocus].size;
});
var NOISE_MASK = {
    left: "linear-gradient(to right, transparent 0%, transparent 50%, black 100%)",
    center: "linear-gradient(to right, transparent 0%, transparent 50%, black 100%)",
};
exports.Noise = (0, styled_components_1.default)(noise_1.Noise)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mask-image: ", ";\n\n  &:before {\n    background-size: 75px;\n  }\n\n  &:after {\n    background-size: 85px;\n  }\n"], ["\n  mask-image: ", ";\n\n  &:before {\n    background-size: 75px;\n  }\n\n  &:after {\n    background-size: 85px;\n  }\n"])), function (_a) {
    var $contentFocus = _a.$contentFocus;
    return NOISE_MASK[$contentFocus];
});
exports.Content = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
